// Fernbedienung für das Menü der Bottom-Navigation.
//
// Auf schmalen Geräten liegen Nutzerwechsel und Hilfe hinter dem
// Menü-Knopf. Die Einführungstour zeigt aber auf beide — sie muss das
// Menü also öffnen können, ohne den Zustand von PageLayout zu kennen.
//
// Dasselbe Muster wie lib/reauth.ts: die Komponente meldet sich an,
// wer sie braucht, ruft die Funktion. Kein Context, weil die Tour von
// ausserhalb des Baums gesteuert wird.

type Steuerung = { oeffnen: () => void; schliessen: () => void };

let aktiv: Steuerung | null = null;

/** Meldet das Menü an. Rückgabe wieder aufrufen beim Aushängen. */
export function registriereMobilMenue(s: Steuerung): () => void {
  aktiv = s;
  return () => {
    if (aktiv === s) aktiv = null;
  };
}

/** Öffnet das Menü, falls eines im Baum hängt (sonst wirkungslos). */
export function mobilMenueOeffnen(): void {
  aktiv?.oeffnen();
}

/** Schliesst das Menü, falls eines offen ist. */
export function mobilMenueSchliessen(): void {
  aktiv?.schliessen();
}

/** Hängt gerade ein Mobil-Menü im Baum? Nur für Tests und die Tour. */
export function mobilMenueVorhanden(): boolean {
  return aktiv !== null;
}
